import { Component, OnInit, ViewChild } from '@angular/core'
import { MatTableDataSource } from '@angular/material/table'
import { PerfilService } from 'src/app/services/perfil.service'
import { ActivatedRoute } from '@angular/router'
import { PerfisDoUsuario } from 'src/app/models/perfil'
import { MatSort } from '@angular/material/sort'
import { MatPaginator } from '@angular/material/paginator'

@Component({
  selector: 'app-lista-perfil-por-usuario',
  templateUrl: './lista-perfil-por-usuario.component.html',
  styleUrls: ['./lista-perfil-por-usuario.component.css'],
  standalone: false
})
export class PropgListaPerfilPorUsuarioComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator
  @ViewChild(MatSort) sort!: MatSort

  dataSource: MatTableDataSource<PerfisDoUsuario> = new MatTableDataSource()
  colunasGrid: string[] = ['nome', 'descricao']

  identificacao: string = ''

  constructor(private perfilService: PerfilService, private route: ActivatedRoute) {}

  perfisDoUsuario: PerfisDoUsuario[] = []

  listaPerfisDoUsuario(identificacao: string): any {
    this.perfilService.listaPerfisDoUsuario(identificacao).subscribe(perfisDoUsuario => {
      this.dataSource.data = perfisDoUsuario
      return perfisDoUsuario
    })
  }

  search(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.dataSource.filter = filterValue.trim().toLowerCase()
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.identificacao = params['identificacao']
      if (this.identificacao) {
        this.identificacao = this.identificacao.replace('@unesp.br', '')
        this.perfilService.listaPerfisDoUsuario(this.identificacao).subscribe(obj => {
          this.perfisDoUsuario = obj
          this.dataSource.data = this.perfisDoUsuario
          this.dataSource.sort = this.sort
          this.dataSource.paginator = this.paginator
        })
      }
    })
  }
}
